import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import the hook for navigation
import Submission from './Submission';
import ScrollToTop from './ScrollToTop';

const SubmissionMessage = ({ roundNumber, teamId }) => {
    const [isSubmissionVisible, setIsSubmissionVisible] = useState(false);
    const navigate = useNavigate(); // Initialize the navigation hook

    const handleViewSubmission = () => {
        setIsSubmissionVisible(!isSubmissionVisible);
    };

    const handlePlayRound2 = () => {
        navigate(`/${teamId}/decision-tool-2`);
    };

    const handlePlayRound3 = () => {
        navigate(`/${teamId}/decision-tool-3`);
    };

    const handleGiveFeedback = () => {
        navigate(`/${teamId}/feedback`);
    };

    return (
        <div>
            < ScrollToTop />
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <h2>Thank you for your submission! Your response has been recorded. Round {roundNumber} is now locked.</h2>

                <button onClick={handleViewSubmission}>
                    {isSubmissionVisible ? 'Hide Submission' : 'View Submission'}
                </button>

                {isSubmissionVisible && <Submission roundNumber={roundNumber} teamId={teamId} />}

                {/* Conditionally render the Play Round 2 button if the current round is 1 */}
                {roundNumber === 1 && (
                    <button onClick={handlePlayRound2} style={{ marginLeft: '10px' }}>
                        Play Round 2
                    </button>
                )}
                {roundNumber === 2 && (
                    <button onClick={handlePlayRound3} style={{ marginLeft: '10px' }}>
                        Play Round 3
                    </button>
                )}
                {roundNumber === 3 && (
                    <button onClick={handleGiveFeedback} style={{ marginLeft: '10px' }}>
                        Feedback
                    </button>
                )}
            </div>
        </div>
    );
};

export default SubmissionMessage;
